import { render, staticRenderFns } from "./editquiz.vue?vue&type=template&id=58e9ca9b&"
import script from "./editquiz.vue?vue&type=script&lang=js&"
export * from "./editquiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports